import React from "react";
import { Skeleton } from "antd";

const BannerSkeleton = () => {
  return (
    <div style={{ height: "70vh", background: "#f2f2f2" }}>
      <Skeleton.Image style={{ width: "100%", height: "100%" }} active />
    </div>
  );
};

export default BannerSkeleton;
